import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";
import "firebase/analytics";
import "firebase/messaging";

export default firebase.initializeApp((window as any).firebaseAppConfig);
